import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { pinia } from '@/pinia';
import { hiddenRoutes } from '@/router/hidden.router';
import { useOrganizationStore } from '@/stores/organzation.pinia';

import { EnumRoutes } from './routes.enum';

const orgStore = useOrganizationStore(pinia);
const { dashboardText, coursesText } = storeToRefs(orgStore);
const baseHeaderItems = computed(() => [
  { ...EnumRoutes.dashboard.root, title: dashboardText.value },
  { ...EnumRoutes.lms.allCourses, title: coursesText.value },
  {
    ...EnumRoutes.lms.myCourses,
    title: 'course.myCourses',
  },
]);
const headerItemsUnAuth = computed(() => [
  { ...EnumRoutes.lms.allCourses, title: coursesText.value },
  EnumRoutes.landing.contactUs,
]);
const headerProfileItems = computed(() => [
  EnumRoutes.profile.root,
  EnumRoutes.financials.myPurchases,
]);
export const EnumHeaderList = computed(() => ({
  headerItemsAuth: [
    ...baseHeaderItems.value.filter(
      (item) => !hiddenRoutes.includes(item.name)
    ),
  ],
  headerItemsUnAuth: headerItemsUnAuth.value.filter(
    (item) => !hiddenRoutes.includes(item.name)
  ),
  headerProfileItems: headerProfileItems.value.filter(
    (item) => !hiddenRoutes.includes(item.name)
  ),
}));
